import React from "react";

const InitialButton = ({ onClick, title }) => {
  return (
    <div className="p-2 bd-highlight">
      <button
        type="button"
        className="green-buttonQuiz buttonQuiz"
        onClick={onClick}
      >
        {title}
      </button>
    </div>
  );
};
export default InitialButton;
